export default __webpack_public_path__ + "static/left-64ab7c03431450da1fdb4be4933d9890.svg";